import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { UsuarioResponse } from '../../../dtos/core/usuario/UsuarioResponse';
import { SyncUsuarioClientePerfilDto } from '../../../dtos/core/usuario/SyncUsuarioClientePerfilDto';
import { UsuarioClientePerfilResponse } from '../../../dtos/core/usuario/UsuarioClientePerfilResponse';
import { UpdateUsuarioDto } from '../../../dtos/core/usuario/UpdateUsuarioDto';
import { LockUnlockUsuarioDto } from '../../../dtos/core/usuario/LockUnlockUsuarioDto';
import { UpdateUsuarioLoggedDto } from '../../../dtos/core/usuario/UpdateUsuarioLoggedDto';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private baseUrl = `${environment.apiUrl}/core/usuario`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<UsuarioResponse[]>> {
    return this.http.get<ResponseApi<UsuarioResponse[]>>(this.baseUrl);
  }

  getById(id: string): Observable<ResponseApi<UsuarioResponse>> {
    return this.http.get<ResponseApi<UsuarioResponse>>(`${this.baseUrl}/${id}`);
  }

  getUserLogged(): Observable<ResponseApi<UsuarioResponse>> {
    return this.http.get<ResponseApi<UsuarioResponse>>(`${this.baseUrl}/userLogged`);
  }

  syncClientePerfil(request: SyncUsuarioClientePerfilDto): Observable<ResponseApi<UsuarioClientePerfilResponse[]>> {
    return this.http.put<ResponseApi<UsuarioClientePerfilResponse[]>>(
      `${this.baseUrl}/SyncClientePerfil`,
      request
    );
  }

  getClientePerfil(usuarioId: string): Observable<ResponseApi<UsuarioClientePerfilResponse[]>> {
    return this.http.get<ResponseApi<UsuarioClientePerfilResponse[]>>(`${this.baseUrl}/ClientePerfil/${usuarioId}`);
  }

  update(request: UpdateUsuarioDto): Observable<ResponseApi<UsuarioResponse>> {
    return this.http.put<ResponseApi<UsuarioResponse>>(this.baseUrl, request);
  }

  updateUsuarioLogged(request: UpdateUsuarioLoggedDto): Observable<ResponseApi<UsuarioResponse>> {
    return this.http.put<ResponseApi<UsuarioResponse>>(`${this.baseUrl}/updateUserLogged`, request);
  }

  lockUnlock(request: LockUnlockUsuarioDto): Observable<ResponseApi<UsuarioResponse>> {
    return this.http.post<ResponseApi<UsuarioResponse>>(`${this.baseUrl}/LockUnlock`, request);
  }
}
